import { segmentTextByPhoneNumbers } from "@Light/utils/phoneNumber";
import { Fragment } from "react";

type BylineTextProps = {
  text: string;
  className?: string;
};

export function BylineText({ text, className }: BylineTextProps) {
  const segments = segmentTextByPhoneNumbers(text);

  return (
    <span className={className}>
      {segments.map((segment, index) => {
        if (segment.type === "text") {
          return <Fragment key={`text-${index}`}>{segment.value}</Fragment>;
        }

        return (
          <a
            key={`phone-${index}`}
            href={segment.telHref}
            className="underline"
          >
            {segment.value}
          </a>
        );
      })}
    </span>
  );
}
